
import { Box, BoxProps, styled } from "@mui/material";

type VerticalAlign = 'start' | 'center' | 'end';
type HorizontalAlign = 'start' | 'center' | 'end';

export const Center = styled(Box, { shouldForwardProp: (props) => props !== 'ha' && props !== 'va' })<BoxProps & { ha?: HorizontalAlign, va?: VerticalAlign }>(({ ha, va }) => ({
    display: 'flex',
    justifyContent: ha ?? 'center',
    alignItems: va ?? 'center'
}));

export default Center;